module.exports = __webpack_public_path__ + "static/img/03.fa78acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sub/worship/03.png
// module id = GPj1
// module chunks = 1